import { ReactNode, useMemo } from "react";
import { useRecoilValue } from "recoil";

import { useDynamicFormsUtils, usePageContext } from "@ryde/redux";
import {
  FILTER_FIELD_VALUE_ID,
  FILTERABLE_FILTER_BASIC_FIELDS,
  IFilterDetail,
  tableFiltersSchemaAtomFamily,
} from "@ryde/shared";

import { PageHeaderFiltersItem } from "./page-header-filters-item";

export const PageHeaderFiltersList = (): ReactNode => {
  const { entity } = usePageContext();
  const { getCustomFieldById } = useDynamicFormsUtils();
  const filtersSchema = useRecoilValue(tableFiltersSchemaAtomFamily(entity));

  const filters = useMemo(() => {
    return Object.entries(filtersSchema ?? {}).reduce<IFilterDetail[]>(
      (acc, [key, value]) => {
        const control = getCustomFieldById(Number(key));

        if (
          !control ||
          !FILTERABLE_FILTER_BASIC_FIELDS.has(
            control.filterFieldTypeId as FILTER_FIELD_VALUE_ID,
          )
        ) {
          return acc;
        }

        acc.push({
          control,
          filterId: key,
          filterValue: value,
        });
        return acc;
      },
      [],
    );
  }, [filtersSchema, getCustomFieldById]);

  return filters.map(filter => {
    return <PageHeaderFiltersItem key={filter.filterId} filter={filter} />;
  });
};
